import React, { useCallback, useState } from "react";
import {
  Grid,
  Button,
  Typography,
  InputAdornment,
  Stack,
  TextField,
  Paper,
  Box,
  Select,
  MenuItem,
} from "@mui/material";
import { useStyles } from "./styles";
import StudentActive from "../../../assets/images/attendance/studentActive.png";

import useAttendance from "../../../Hooks/attendance";
import useCourse from "../../../Hooks/course";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";

import useAuthStore from "../../../Hooks/auth";
import CustomExpandMore from "../../../common/CustomExpandMore";

import UnstyledTabsCustomized from "../../../components/Tabs";

const TABDATA = [
  {
    label: "Year",
    value: "year",
  },
  {
    label: "DEPARTMENT",
    value: "department",
  },
];
const studentAttendanceSchema = Yup.object().shape({
  fromDate: Yup.string().required("* Please fill start date"),
  toDate: Yup.string().required("* Please fill end date"),
  idDepartment: Yup.string().required("* Please select department"),
});
const studentAttendanceSchemaYear = Yup.object().shape({
  year: Yup.number()
    .min(1, "Year must be more than 1")
    .max(7, "Year must be less than 7")
    .required("* Please enter year"),
  idDepartment: Yup.string().required("* Please select department"),
});

const AttendanceManagement = () => {
  const classes = useStyles();
  const {
    studentAttendancePercentageYearWise,
    studentAttendancePercentageDeptWise,
    resetStudentAtttendanceAction,
    resetStaffAtttendanceAction,
    clearStudentAttendancePercentageAction,
    getStudentAttendancePercentageDateRangeDepartmentWiseAction,
    getStudentAttendancePercentageYearWiseAction,
  } = useAttendance();
  const formRef = React.useRef();

  const { getDepartmentAction, departmentData } = useCourse();
  const [activeTab, setActiveTab] = useState("year");
  const { institutionId } = useAuthStore();

  React.useEffect(() => {
    resetStudentAtttendanceAction();
    resetStaffAtttendanceAction();
    return () => {
      clearStudentAttendancePercentageAction();
    };
  }, []);

  React.useEffect(() => {
    getDepartmentAction({
      department: {
        institutionId,
      },
    });
  }, []);

  const initStudentAttendance = {
    fromDate: "",
    toDate: "",
    idDepartment: "",
    year: "",
  };
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
    clearStudentAttendancePercentageAction();
    formRef.current.resetForm();
  };
  return (
    <Grid container className={classes.attendance}>
      <Grid item lg={10} sm={12}>
        <Stack sx={{ flexDirection: "column" }}>
          <Stack sx={{ flexDirection: "row", my: 2, flexWrap: "wrap" }}>
            <img
              src={StudentActive}
              className={classes.imggap}
              alt="attendance2"
              role={"button"}
              style={{ cursor: "pointer" }}
              draggable="false"
            />
          </Stack>
        </Stack>
      </Grid>
      <Grid item lg={10} sm={12} sx={{}}>
        <Stack
          sx={{
            alignItems: "center",
          }}
        >
          <UnstyledTabsCustomized
            value={activeTab}
            onChange={handleChange}
            data={TABDATA}
            defaultValue={"year"}
          ></UnstyledTabsCustomized>
        </Stack>
      </Grid>
      <Grid item lg={10} sm={12}>
        <Stack
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            display: "flex",
            my: 2,
            gap: 2,
          }}
        >
          <Formik
            initialValues={initStudentAttendance}
            validationSchema={
              activeTab === "department"
                ? studentAttendanceSchema
                : studentAttendanceSchemaYear
            }
            validateOnBlur={false}
            validateOnChange={false}
            enableReinitialize
            innerRef={formRef}
            onSubmit={(values) => {
              if (activeTab === "department") {
                getStudentAttendancePercentageDateRangeDepartmentWiseAction({
                  ...values,
                  departmentId: values.idDepartment,
                  fromDate: values.fromDate,
                  toDate: values.toDate,
                  institutionId,
                });
              } else {
                getStudentAttendancePercentageYearWiseAction({
                  ...values,
                  departmentId: values.idDepartment,
                  year: values.year,
                  institutionId,
                });
              }
            }}
          >
            {(formik) => {
              const {
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                values,
              } = formik;
              return (
                <>
                  <form
                    onSubmit={handleSubmit}
                    className={classes.attendanceForm}
                  >
                    <Stack
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        display: "flex",
                        gap: 1,
                      }}
                    >
                      <Typography className={classes.textgap}>
                        Department
                      </Typography>
                      <Stack>
                        <Select
                          id="idDepartment"
                          name="idDepartment"
                          className={
                            errors.idDepartment && touched.idDepartment
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          value={values.idDepartment}
                          onChange={handleChange}
                          placeholder="what's your favourite car?"
                          IconComponent={CustomExpandMore}
                          sx={{
                            width: 180,
                          }}
                          displayEmpty
                        >
                          <MenuItem disabled value="">
                            <span>Select Department</span>
                          </MenuItem>
                          {typeof departmentData !== "undefined"
                            ? departmentData.map((_el) => (
                                <MenuItem value={_el.id}>{_el.name}</MenuItem>
                              ))
                            : null}
                        </Select>
                        <ErrorMessage
                          name="idDepartment"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>

                    {activeTab === "department" && (
                      <>
                        {" "}
                        <Stack
                          sx={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            display: "flex",
                            gap: 1,
                          }}
                        >
                          <Typography className={classes.textgap}>
                            Date From
                          </Typography>
                          <Stack>
                            <TextField
                              id="fromDate"
                              type="date"
                              name="fromDate"
                              sx={{
                                width: "180px",
                              }}
                              value={values.fromDate}
                              onChange={handleChange}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              placeholder="Enter Date From"
                            />
                            <ErrorMessage
                              name="fromDate"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          sx={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            display: "flex",
                            gap: 1,
                          }}
                        >
                          <Typography className={classes.textgap}>
                            Date To
                          </Typography>
                          <Stack>
                            <TextField
                              id="toDate"
                              type="date"
                              name="toDate"
                              sx={{
                                width: "180px",
                              }}
                              value={values.toDate}
                              onChange={handleChange}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              placeholder="Enter Date To"
                            />
                            <ErrorMessage
                              name="toDate"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>
                        </Stack>
                      </>
                    )}

                    {activeTab === "year" && (
                      <>
                        {" "}
                        <Stack
                          sx={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            display: "flex",
                            gap: 1,
                          }}
                        >
                          <Typography className={classes.textgap}>
                            Year
                          </Typography>
                          <Stack>
                            <TextField
                              id="year"
                              type="number"
                              name="year"
                              placeholder="Select Year"
                              sx={{
                                width: 251,
                              }}
                              className={
                                errors.year && touched.year
                                  ? classes.inputError
                                  : classes.inputNoError
                              }
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.year}
                            />

                            <ErrorMessage
                              name="year"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>
                        </Stack>
                      </>
                    )}

                    <Stack>
                      <Button
                        type="submit"
                        sx={{
                          px: 4,
                          py: 1,
                          borderRadius: "50px",
                          minWidth: "150px",
                        }}
                        className={classes.search_btn}
                      >
                        View
                      </Button>
                    </Stack>
                  </form>
                </>
              );
            }}
          </Formik>
        </Stack>
      </Grid>
      <Grid item lg={10} sm={12}>
        <Stack sx={{ my: 4 }}>
          <Box sx={{ width: "100%" }}>
            <Paper
              sx={{
                width: "100%",
                borderRadius: "20px",
                filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                boxShadow: "none",
              }}
            >
              <Stack
                sx={{
                  padding: "12px 32px",
                }}
              >
                {studentAttendancePercentageYearWise ||
                studentAttendancePercentageDeptWise ? (
                  <>
                    <Stack style={{ textAlign: "center" }}>
                      <Typography className={classes.student_attendance_text}>
                        Attendance Percentage :
                        <span
                          className={classes.student_attendance_percentage_text}
                        >
                          {activeTab === "year" &&
                            studentAttendancePercentageYearWise?.attendancePercentage}
                          {activeTab === "department" &&
                            studentAttendancePercentageDeptWise?.attendancePercentage}
                          %
                        </span>
                      </Typography>
                    </Stack>
                  </>
                ) : (
                  <></>
                )}
              </Stack>
            </Paper>
          </Box>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default AttendanceManagement;
